import {Component, OnDestroy, OnInit} from '@angular/core';
import {UtilsService} from '../../../../core/utils/utils.service';
import {Subscription} from 'rxjs';
import {SearchSupplierWrapper} from '../../../../core/suppliers/wrappers/search-supplier-wrapper';
import {DATEPICKER_FR, MSG_KEY, MSG_SEVERITY} from '../../../../core/constants';
import {catchError} from 'rxjs/operators';
import {UniteDeProduction__denreeInterditeDto} from '../../../../core/dtos/unite-de-production__denree-interdite-dto';
import {UniteDeProduction__denreesInterditesService} from '../../../../core/services/entities/unite-de-production__denrees-interdites.service';
import {ToastService} from "../../../../core/services/technique/toast.service";
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-dialog-modifier-denree-interdite',
    templateUrl: './dialog-modifier-denree-interdite.component.html',
    styleUrls: ['./dialog-modifier-denree-interdite.component.scss'],
    standalone: false
})
export class DialogModifierDenreeInterditeComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  subOpenDialog: Subscription;
  selectedUdpDenreeInterdite: UniteDeProduction__denreeInterditeDto;

  displayDialog = false;
  ssw: SearchSupplierWrapper;

  localeFr = DATEPICKER_FR;

  constructor(public utils: UtilsService,
              private udpDenreeInterditeSvc: UniteDeProduction__denreesInterditesService,
              private toastSvc: ToastService) {
  }

  ngOnInit() {
    this.subscriptionOpenDialog();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subOpenDialog);
  }

  subscriptionOpenDialog = () => {
    this.subOpenDialog = this.udpDenreeInterditeSvc.openDialogModifierDenree$.pipe(
      catchError(err => this.utils.handleError(err))
    ).subscribe(response => {
      this.selectedUdpDenreeInterdite = response.uniteDeProductionDenreeInterditeDto;
      this.displayDialog = true;
    });
  };

  closeDialog = () => {
    this.displayDialog = false;
  };


  startError = (property: string) => `Le champ "${property.toUpperCase()}" `;

  modifierDenreeDeSubstitution = () => {
    this.udpDenreeInterditeSvc.save(this.selectedUdpDenreeInterdite).subscribe(response => {
      if (!this.utils.isNullOrEmpty(response.one)) {
        this.udpDenreeInterditeSvc.announceLoadDenreesByUdp();
        this.closeDialog();
      } else {
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Modification impossible`);
      }
    });
  };

  getMesureDenreeSubstitution = () => {
    if (this.selectedUdpDenreeInterdite.ratio === 0 ||
      this.selectedUdpDenreeInterdite.denreeInterditeRatioUniteTechnique === 0 ||
      this.selectedUdpDenreeInterdite.denreeSubstitutionRatioUniteTechnique === 0) {
      return 0;
    } else {
      return Number(this.selectedUdpDenreeInterdite.ratio / 100);
    }
  };
}
